import { PLATFORM_LIST_TOLGEE_NAMES } from "../config/constants";

export const preLoadImages = async (images: string[]): Promise<void> => {
  let img;
  for (let i = 0, len = images.length; i < len; ++i) {
    img = new Image();
    img.src = images[i];
  }
};

export const measureExecutionTime = (func) => {
  return (...args) => {
    console.time("Function Execution");

    const result = func(...args);

    console.timeEnd("Function Execution");

    return result;
  };
};
export const getPlatformTranslationKey = (platform: string) => {
  return PLATFORM_LIST_TOLGEE_NAMES[platform];
};
